import { Button, Stack, Switch } from '@mui/material';
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react';
import {
  FlowPatientDataStoreFilterMatchRule,
  type FlowPatientDataStoreFilterOperation,
} from 'flow-schema';
import { useState } from 'react';

import { Text, isDefined } from 'common';

import { FilterOperationFields } from './FilterOperationFields.tsx';
import { SortBlockFormFields } from './SortFormFields.tsx';
import { FILTER_BLOCK_MATCH_RULE_NAMES } from './constants.ts';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField.ts';

export function FilterAndSortBlockFormFields() {
  const { value: filterMatchRule, setValue: setFilterMatchRule } = useSelectedNodeField<
    (typeof FlowPatientDataStoreFilterMatchRule)[keyof typeof FlowPatientDataStoreFilterMatchRule]
  >('config.baseFilters.filterConfig.matchRule');
  const { value: filterOperations, setValue: setFilterOperations } = useSelectedNodeField<
    FlowPatientDataStoreFilterOperation[]
  >('config.baseFilters.filterConfig.filterOperations');
  const { value: basicFilter } =
    useSelectedNodeField<Record<string, unknown>>('config.baseFilters');
  const [isAdvancedVisible, setIsAdvancedVisible] = useState(
    isDefined(basicFilter) && Object.keys(basicFilter).length > 0
  );

  return (
    <Stack gap={1}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Text variant="heading5" bold>
          Advanced
        </Text>
        <Switch
          checked={isAdvancedVisible}
          onChange={() => {
            setIsAdvancedVisible(!isAdvancedVisible);
            if (!isAdvancedVisible && filterOperations?.length) {
              // remove all filter operations
              setFilterOperations([]);
            }
          }}
        />
      </Stack>

      {isAdvancedVisible && (
        <Stack gap={2}>
          <Stack direction="row" gap={0.5} alignItems="center">
            <Text variant="heading5" bold>
              Filter Operations
            </Text>
            {!!filterOperations?.length && (
              <Button
                variant="text"
                size="small"
                sx={{
                  minWidth: 'unset',
                  paddingY: 0,
                  paddingX: 0.25,
                  gap: 0.5,
                  fontSize: (theme) => theme.typography.h4.fontSize,
                  lineHeight: (theme) => theme.typography.h4.lineHeight,
                }}
                onClick={() => {
                  setFilterMatchRule(
                    filterMatchRule === FlowPatientDataStoreFilterMatchRule.All
                      ? FlowPatientDataStoreFilterMatchRule.Any
                      : FlowPatientDataStoreFilterMatchRule.All
                  );
                }}
              >
                {'match ' +
                  FILTER_BLOCK_MATCH_RULE_NAMES[
                    filterMatchRule ?? FlowPatientDataStoreFilterMatchRule.All
                  ]}
                <ArrowCounterClockwiseIcon size={12} />
              </Button>
            )}
          </Stack>
          <Stack gap={2}>
            <FilterOperationFields setFilterMatchRule={setFilterMatchRule} />
            <SortBlockFormFields />
          </Stack>
        </Stack>
      )}
    </Stack>
  );
}
